<template>
	<div>
		<a-modal title="老師評價" :width="650" :visible="visible" @cancel="handleCancel" :closable="false" :footer="null"
			:pagination="false">
			<div class=" d-flex flex-column align-items-center ">
				<img src="../../../assets/image/index/index-ph1.png" alt="" class="photo-40" />
				<div class="mt-3 ftr-1-25">
					Rose
				</div>
				<div class="cl-info mt-3">
					課堂滿意度
				</div>
				<a-rate v-model:value="rate" />
				<div class="cl-info mt-2">
					教得超好的
				</div>
				<a-divider />
				<div class="wid-100">
					<div class="cl-info">
						選挥適合老師Rose的教學特質標簸
					</div>
					<div class="d-flex flex-wrap">
						<div class="bg-F3F3F3 wid-fit m-2 py-1 px-2" v-for="item in 5">
							可以使用英文講解
						</div>
					</div>
				</div>
				<a-divider />
				<div class="wid-100">
					<div class="cl-info">
						給與老師Rose的課堂回饋
					</div>
					<div class="form-check">
					  <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1">
					  <label class="form-check-label" for="flexRadioDefault1">
					    此回復講展示在老師的個人真面(記名)
					  </label>
					</div>
					<div class="form-check">
					  <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" checked>
					  <label class="form-check-label" for="flexRadioDefault2">
					    此回復講展示在老師的個人夏面(名)
					  </label>
					</div>
					<textarea class="mt-3 border-gray wid-100 p-2 br12" style="height: 150px;" placeholder="寫下你的上課體驗心得"></textarea>
				</div>
				<div class="mt-4 d-flex justify-content-center">
					<button type="button" class="btn btn-outline-gray px-4" @click="handleCancel()"> {{$t('common.cancel')}} </button>
					<button type="button" class="btn btn-theme ml16 px-4">提交</button>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	export default {
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				codeLoading: false,
				account: '',
				rate:3
			}
		},
		created() {
	
		},
		methods: {
			handleCancel() {
				this.$emit('cancel')
			},
	
		}
	}
</script>

<style>
</style>